//文字コードはutf-8

/**
 * ヘッダーロゴのスクロール制御
 * 30pxスクロールしたら、ロゴをふわっと消す
 */
export function initHeaderLogo() {
  const logo = document.querySelector('.header__logo');
  
  if (!logo) {
    return;
  }
  
  let ticking = false;
  
  function handleScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop >= 30) {
          logo.classList.add('is-hidden');
        } else {
          logo.classList.remove('is-hidden');
        }
        
        ticking = false;
      });
      ticking = true;
    }
  }
  
  // 初回実行
  handleScroll();
  
  // スクロール時に実行
  window.addEventListener('scroll', handleScroll, { passive: true });
}

